import { CultureInfo } from '../culture-info.model';
import { CultureInfoAr } from './ar';

/**
 * @ignore
 */
export const CultureInfoArYE: CultureInfo = {
  name: 'ar-YE',
  displayName: 'Arabic (Yemen)',
  iso3LanguageCode: 'ara',
  iso2LanguageCode: 'ar',
  ietfLanguageTag: 'ar-YE',
  parent: CultureInfoAr
};
